import { render, staticRenderFns } from "./WidgetMain.vue?vue&type=template&id=5ea64b3c&scoped=true&"
import script from "./WidgetMain.vue?vue&type=script&lang=js&"
export * from "./WidgetMain.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMain.vue?vue&type=style&index=0&id=5ea64b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea64b3c",
  null
  
)

export default component.exports